import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./vuetify";


import "vuetify/styles"; // 引入 Vuetify 樣式
import "@mdi/font/css/materialdesignicons.css"; // 引入圖示
import VueDatePicker from '@vuepic/vue-datepicker';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// 忽略 ResizeObserver 錯誤
// Suppress ResizeObserver errors
const resizeObserverError = window.console.error;
window.console.error = (...args) => {
  if (args[0].includes("ResizeObserver loop completed with undelivered notifications")) {
    return;
  }
  resizeObserverError(...args);
};


dayjs.extend(isSameOrAfter); // 啟用插件
dayjs.extend(isSameOrBefore);
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.component('VueDatePicker', VueDatePicker);
app.mount("#app");
